import { Component, AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
@Component({
  selector: 'app-admission-details',
  templateUrl: './admission-details.component.html',
  styleUrls: ['./admission-details.component.scss']
})
export class AdmissionDetailsComponent implements OnInit, AfterViewInit {
  @Input() tabName: string = '';
  @Output() next = new EventEmitter<void>();
  // @Output() prev = new EventEmitter<void>();
  @Output() prev = new EventEmitter<boolean>();
  @Output() first = new EventEmitter<void>();
  dialogRef: MatDialogRef<any>;
  courseList: any;
  filteredCourseList: any;
  facultyList: any;
  filteredFacultyList: any;
  courseStreamList: any;
  examList: any;
  filteredExamList: any;
  filteredStreamList: any;
  stucourseClgMapList: any;
  filteredstucourseClgMapListList: any;
  disabled = true;
  showtxt = false;
  notOpen = false;
  AdmClosed = false;
  subList: any;
  filteredSubList: any;
  filteredstudyModeList: any;
  studyModeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  CourseCode: any;
  savebtn: boolean;
  updateBtn: boolean;
  StrCode: any;
  InstId: any;
  Subs = false;
  OptSub = false;
  noCheckboxSelected = false;
  SubjectName: any[] = [];
  AllSub: any[] = [];
  Sub: any[] = [];
  optData: any;
  optDataForGroup: any;
  checkedValues: any;
  code: any;
  msg: any;
  SubjectData = [];
  parsedData: any;
  FromDate: Date;
  ToDate: Date;
  Course: any;
  College: any;
  tabs : string;
  displayName : any;
  SnNo: any;
  disabledCheckbox=false;
  savedisabled =false;
  snNo: number | null = null;
  CourseType: string = '';

  constructor(private fb: FormBuilder, private modalPopupService: ModalpopService,
    public umsService: UmsService, private spinner: NgxSpinnerService, private router: Router) { }
  admissionDetailsForm: FormGroup;
  submitButton = false;
  updateButton = false;
  BranchId = 0;
  admissionDetailsFormArray;
  selectedValues: any[] = [];
  newSelectedValues = [];
  Subjects: any[] = [];
  GroupData: any[] = [];
  selectedCheckboxes: any = [];
  selectedOptions: any = [];
  validationErrors: { [key: string]: string } = {};
  MinMax = false;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  session = sessionStorage.getItem('session');
  studentId = sessionStorage.getItem('StudentRGID');
  sessionList: any[];
  SessionFilterList: any[];
  BranchShow =false;
  subjectsData = false;
  groupedSubjects: { [key: string]: string[] } = {};
  groupedSubjects2: { [key: string]: { [key: string]: any[] } } = {};

  ngOnInit(): void {
   // this.disabled = true;

    this.Subs = false;
    this.OptSub = false;
    this.noCheckboxSelected = false;
    this.MinMax = false;
    this.notOpen = false;
    this.AdmClosed = false;
    this.submitButton = true;
    this.updateButton = false;
    this.validationErrors = {};
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.session = sessionStorage.getItem('session');
    this.disabled = false;
    this.BranchId = 0;
        this.disabledCheckbox =false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
            this.savedisabled =false;
           this.subjectsData = false;
           this.admissionSummary();
    this.admissionDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      SubChecked: new FormControl('')
    });

    this.getFacultyData();
    // this.getScrutiny();
    this.prepopulationContact();
    this.getScretData()
    this.fetchStudyMode();
    this.fetchStudentType();
    this.getScretData();
    this.getSessionData()
    this.getApplyData();
    this.prepopulation();
  }
  ngAfterViewInit(): void {
    console.log("ngAfterViewInit called in admission details");
    this.prepopulation();
  }

  getSecretData() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.SnNo = res.projectPharam['SnNo'];
        this.spinner.hide();
      }
      else{
        this.spinner.hide();
      }
    },(ERROR:HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
    
  getFeeStatus(StuId) {
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = this.session;
    this.umsService.getFeeStatus(payload).subscribe(res => {
      if (res.status) {
        console.log('fees status response i get is', res.data);
        this.getScrutiny(StuId)
      }
      else {
        this.disabled = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.disabled = false;
    })
  }

  admissionSummary() {
  let payload = {};
  payload['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));

  this.umsService.studentCompSummary(payload).subscribe((res) => {
    if (res.status && res.data && res.data.length > 0) {
      this.snNo = res.data[0].SnNo;
      console.log('SessionId / SnNo:', this.snNo);
    }
  });
}

  getApplyData(){
    this.spinner.show();
    let payload = {}
    this.Course = ''
    this.College = ''
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
       this.Course = res.data[0]['Course'];
       this.College = res.data[0]['College'];
      }
      else{
        this.spinner.hide();
        this.Course = ''
        this.College = ''
      }
    }, (ERROR: HttpErrorResponse) => {
      this.Course = ''
      this.College = ''
      this.spinner.hide();
    });
  }

  getCollege(){
    this.spinner.show();
    const payload3 = {};
    payload3['CoCode'] = this.Course;
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.stucourseClgMapList = res.data;
        this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
        if(this.College != ''){
          this.admissionDetailsForm.controls['StuCgId'].setValue(this.College);
        }
        
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  onCheckbox(event: any, checkbox: any): void {
    this.noCheckboxSelected = false;
    if (typeof this.selectedCheckboxes[0] === "object") {
      this.selectedCheckboxes = []
    }
    if (typeof checkbox === "string") {
      const index = this.selectedCheckboxes.indexOf(checkbox);
      const isChecked = event.checked;

      if (isChecked && index === -1) {
        this.selectedCheckboxes.push(checkbox);
      } else if (!isChecked && index !== -1) {
        this.selectedCheckboxes.splice(index, 1);
      }
    }
    else if (typeof checkbox[0] === "object") {
      checkbox.forEach(element => {
        if (typeof element === "string") {
          const index = this.selectedCheckboxes.indexOf(element);
          const isChecked = event.checked;
          if (isChecked && index === -1) {
            this.selectedCheckboxes.push(element);
          } else if (!isChecked && index !== -1) {
            this.selectedCheckboxes.splice(index, 1);
          }
        }
      });
    }

  }

  checkMatchingOpCode(group: any) {
    return this.optData.some(item => item.OpCode === group.EsOpCode);
  }

  onCheckboxChanged(event: any, checkbox: any): void {
    // this added for update button enable and disable
    const payload = {};
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
       if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR' ) {
        this.spinner.hide();
        if(res.data[0].Tabs.includes('Admission Details')){
          this.disabled = false;
           this.disabledCheckbox = false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
            this.savedisabled = true;
        }else{
          this.disabled = true;
           this.disabledCheckbox = true;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
        }
      }
      else if (res.data.length == 0 || res.data[0]['Status'] == 'Submitted' ) {
        this.spinner.hide();
        if(res.data[0].Tabs.includes('Admission Details')){
          this.disabled = true;
           this.disabledCheckbox = false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
            this.savedisabled = false;
        }else{
          this.savedisabled = true;
           this.disabledCheckbox = true;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
        }
      }
      else {
        this.spinner.hide();
        this.disabled = true;
         this.disabledCheckbox = true;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
          this.savedisabled = true;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    this.noCheckboxSelected = false;
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
    // this.validateCheckboxesForItem();
     this.handleRelatedCheckboxes(event, checkbox);
  }

    private handleRelatedCheckboxes(event: any, checkbox: any): void {
    const isChecked = event.checked;
    console.log('isChecked',isChecked)
    if (isChecked) {
      // Select and enable EsCombCode subjects
      if (checkbox.EsCombCode) {
        const combCodes = checkbox.EsCombCode.split(','); // Handle multiple EsCombCode values
        this.SubjectData.forEach((subject: any) => {
          if(subject.EsType == 'G'){
            subject.children.forEach((childSubject: any) => {
              if(combCodes.includes(childSubject.EsCode)){
                childSubject.checked = true;
                childSubject.disabled = false;
                // if (!this.selectedCheckboxes.includes(childSubject)) {
                //   this.selectedCheckboxes.push(childSubject);
                // }
                if (!this.selectedCheckboxes.some((s: any) => s.EsCode === childSubject.EsCode)) {
                  this.selectedCheckboxes.push(childSubject);
                }
              }
            })
          }
          else if(subject.EsType == 'S'){
            if (combCodes.includes(subject.EsCode)) {
              subject.checked = true;
              subject.disabled = false;
              // if (!this.selectedCheckboxes.includes(subject)) {
              //   this.selectedCheckboxes.push(subject);
              // }
              if (!this.selectedCheckboxes.some((s: any) => s.EsCode === subject.EsCode)) {
                this.selectedCheckboxes.push(subject);
              }
            }
          }
        });
      }
  
      // Deselect and disable EsNoComb subjects
      if (checkbox.EsNoComb) {
        const noCombCodes = checkbox.EsNoComb.split(','); // Handle multiple EsNoComb values
        this.SubjectData.forEach((subject: any) => {
          if(subject.EsType == 'G'){
            subject.children.forEach((childSubject: any) => {
              if(noCombCodes.includes(childSubject.EsCode)){
                childSubject.checked = false;
                childSubject.disabled = true;
                const noCombIndex = this.selectedCheckboxes.findIndex((s: any) => s.EsCode === childSubject.EsCode);
                if(noCombIndex !== -1){
                  this.selectedCheckboxes.splice(noCombIndex, 1);
                }
              }
            })
          }
          else if(subject.EsType == 'S'){
            if (noCombCodes.includes(subject.EsCode)) {
              subject.checked = false;
              subject.disabled = true;
              const noCombIndex = this.selectedCheckboxes.findIndex((s: any) => s.EsCode === subject.EsCode);
              if (noCombIndex !== -1) {
                this.selectedCheckboxes.splice(noCombIndex, 1);
              }
              
            }
          }
          
        });
      }
    } else {
      // Deselect and enable EsCombCode subjects
      if (checkbox.EsCombCode) {
        const combCodes = checkbox.EsCombCode.split(','); // Handle multiple EsCombCode values
        this.SubjectData.forEach((subject: any) => {
          if(subject.EsType == 'G'){
            subject.children.forEach((childSubject: any) => {
              if(combCodes.includes(childSubject.EsCode)){
                childSubject.checked = false;
                childSubject.disabled = false;
                const combIndex = this.selectedCheckboxes.indexOf(childSubject);
                if(combIndex !== -1){
                  this.selectedCheckboxes.splice(combIndex, 1);
                }
              }
            })
          }
          else if(subject.EsType == 'S'){
            if (combCodes.includes(subject.EsCode)) {
              subject.checked = false;
              subject.disabled = false;
              const combIndex = this.selectedCheckboxes.indexOf(subject);
              if (combIndex !== -1) {
                this.selectedCheckboxes.splice(combIndex, 1);
              }
            }
          }
         
        });
  }

      // Deselect and enable EsNoComb subjects
      if (checkbox.EsNoComb) {
        const noCombCodes = checkbox.EsNoComb.split(','); // Handle multiple EsNoComb values
        this.SubjectData.forEach((subject: any) => {
          if(subject.EsType == 'G'){
            subject.children.forEach((childSubject: any) => {
              if(noCombCodes.includes(childSubject.EsCode)){
                childSubject.checked = false;
                childSubject.disabled = false;
                const noCombIndex = this.selectedCheckboxes.findIndex((s: any) => s.EsCode === childSubject.EsCode);
              if (noCombIndex !== -1) {
                this.selectedCheckboxes.splice(noCombIndex, 1);
              }
              }
            })
          }
          else if(subject.EsType == 'S'){
            if (noCombCodes.includes(subject.EsCode)) {
              subject.checked = false;
              subject.disabled = false;
              const noCombIndex = this.selectedCheckboxes.findIndex((s: any) => s.EsCode === subject.EsCode);
              if (noCombIndex !== -1) {
                this.selectedCheckboxes.splice(noCombIndex, 1);
              }
            }
          }
        });
      }
    }
  
    this.validateCheckboxesForItem();
    // Update UI or re-render view
    this.SubjectData = [...this.SubjectData];
  }
  validateCheckboxesForItem(): void {

    for (const item of this.optData) {
      const selectedForItem = this.selectedCheckboxes.filter(
        (checkbox) => checkbox.EsOpCode === item.OpCode
      );
      this.validateCheckboxes(item, selectedForItem);
    }
  }

  // validateCheckboxes(item: any, selectedCheckboxes1: any[]): void {

  //   const totalSelected = selectedCheckboxes1.length;
  //   const opMin = item.OpMin;
  //   const opMax = item.OpMax;
  //   const opCode = item.OpCode
  //   if (totalSelected < opMin || totalSelected > opMax) {
  //     this.validationErrors[item.OpCode] = `For OptionCode ${opCode} Select Minimum ${opMin} or Maximum ${opMax}`;
  //     this.disabled = true;
  //   } else {
  //     delete this.validationErrors[item.OpCode];
  //     this.noCheckboxSelected = false;
  //     if (this.showtxt == false && this.notOpen == false && this.AdmClosed == false) {
  //       this.disabled = false;
  //     }
  //     else {
  //       this.disabled = true
  //     }

  //   }
  //   this.getValidationErrorsKeys()
  // }

  validateCheckboxes(item: any, selectedCheckboxes1: any[]): void {

    const totalSelected = selectedCheckboxes1.length;
    const opMin = item.OpMin;
    const opMax = item.OpMax;
    const opCode = item.OpCode
    if (totalSelected < opMin || totalSelected > opMax) {
      if(opMin == opMax){
        this.validationErrors[item.OpCode] = `For Option ${opCode} Select Only ${opMin}`;
      }
      else if(opMin != opMax){
        this.validationErrors[item.OpCode] = `For Option ${opCode} : Select min ${opMin} or max ${opMax} option`;
      }
      
      //  this.disabled = true;
      // save disabled for checkbox not selected
      this.savedisabled = true
      this.disabledCheckbox =false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
    } else {
      delete this.validationErrors[item.OpCode];
      this.noCheckboxSelected = false;
      if (this.showtxt == false && this.notOpen == false && this.AdmClosed == false) {
        this.disabled = false;
        this.disabledCheckbox =false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
        this.savedisabled = false;
      }
      else {
        // this.disabled = true
        // this.savedisabled =true;
        this.disabledCheckbox =false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
      }

    }
    this.getValidationErrorsKeys()
  }

  getValidationErrorsKeys(): string[] {
    return Object.keys(this.validationErrors);
  }

  getScretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.InstId = res.projectPharam['ClubPartTrans'];
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  onSelectionChange(event: any) {
  
    this.newSelectedValues = event.value
  }

  getScrutiny(StuId) {
    this.spinner.show();
    const payload = {};
    payload['StudentId'] = StuId
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
       if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
        this.spinner.hide();
        if(res.data[0].Tabs.includes('Admission Details')){
          this.disabled = false;
           this.disabledCheckbox =false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
        }else{
          this.disabled = true;
           this.disabledCheckbox =true;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
        }
      }
      else {
        this.spinner.hide();
        this.disabled = true;
         this.disabledCheckbox =true;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }


  prepopulation() {
    this.newSelectedValues = [];
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      console.log("res status in admission details: ",res.status);
      if (res.status) {
       
        res.data[0].StuBrId = parseInt(res.data[0].StuBrId);
        res.data[0].StuEmId = parseInt(res.data[0].StuEmId);
        if (res.data[0].StuSubjectRg) {
          res.data[0].StuSubjectRg = res.data[0].StuSubjectRg.split(",");
        } else {
          res.data[0].StuSubjectRg = [];
        }
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          sessionStorage.setItem("StuAcadId", res.data[0].StuAcadId);
          sessionStorage.setItem("StuRegSessionId", res.data[0].SessionId); 
          // this.umsService.disable7 = false;
          
          this.getExamStreamData(res.data[0].StuCoId);
          this.selectedValues = res.data[0].StuSubjectRg;
          const dataArray = res.data[0].StuSubjectRgCopy.split(',');
          
          
          dataArray.forEach(item =>{   
          const splitValues = item.split('-');   
          const Id= splitValues.pop(); 
          // Extract the last element as Id
          const Code = splitValues.join('-'); 
          // remaining Code
          const  obj = {Code,Id};  
           this.newSelectedValues.push(obj); 
          });
          this.submitButton = false;
          this.updateButton = true;
          this.getFeeStatus(res.data[0].StuId)
          this.prepopulatedatapage(res);

        } else {
          this.loadsettingspage();
        }
      } else {
        this.spinner.hide();
        this.loadsettingspage();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  shouldCheckItemForGroup(child): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === child.EsId);
  }

  shouldCheckItemForSubject(item1): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === item1.EsId);
    
  }

  prepopulatedatapage(e) {
    this.spinner.show()
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide()
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            } else {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          }
          else {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            } else {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
          }
        }
        else {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.admissionDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.getCourseData(this.Course);
      this.getCollege();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

  }

  NewCoSch(CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    payload['CShStatus'] = '';
    payload['LoginId'] = 0;
    payload['CShSnNo'] = CShSnNo;
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.NewSearchCoSch(res.data[0]['CShId'], CoCode, CShSnNo, StuId, StuCgId)
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  NewSearchCoSch(ShId, CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    const payload = {};
    payload['CEcShId'] = ShId;
    this.umsService.NewSearchCoSch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.personalDetails(res.data[0]['CEcId'], CoCode, CShSnNo, StuId, StuCgId)
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  personalDetails(ECID, CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = this.studentId
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        let data = res.data[0]
        this.RegnForm(ECID, CoCode, CShSnNo, StuId, StuCgId, data.StuFirstNameEng, data.StuRgNo, data.StuMidNameEng, data.StuBirthDate, data.EmailID)
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  RegnForm(EcId, CoCode, CShSnNo, StuId, StuCgId, Name, RgNo, Father, BirthDate, EMail) {
    this.spinner.show();
    const payload = {};
    payload['CSExBr'] = '';
    payload['Code'] = '';
    payload['Colg'] = '';
    payload['valid'] = 'Y';
    payload['changed'] = '';
    payload['CgCodee'] = '';
    payload['Batch'] = '';
    payload['Name'] = Name;
    payload['RgNo'] = RgNo;
    payload['FormNo'] = '';
    payload['CgCode'] = StuCgId;
    payload['Chng'] = 'Y';
    payload['Valid'] = '';
    payload['Father'] = Father;
    payload['Mother'] = '';
    payload['BirthDate'] = BirthDate;
    payload['Sex'] = 'M';
    payload['Cate'] = 'R';
    payload['Caste'] = 'OBC';
    payload['EMail'] = EMail;
    payload['Medium'] = 'E';
    payload['Nation'] = '1';
    payload['Mobile'] = '';
    payload['Addr1'] = '';
    payload['Addr2'] = '';
    payload['Addr3'] = '';
    payload['Addr1P'] = '';
    payload['Addr2P'] = '';
    payload['Addr3P'] = '';
    payload['Pin'] = '';
    payload['PinP'] = '';
    payload['Place'] = '';
    payload['StrCode'] = this.StrCode ? this.StrCode : 0;
    payload['PlaceP'] = '';
    payload['ExSub'] = '';
    payload['Sub'] = '';
    payload['EcId'] = EcId;
    payload['CoCode'] = CoCode;
    payload['SnNo'] = CShSnNo;
    payload['EmSrNoF'] = '';
    payload['msg'] = '';
    payload['EmSkip'] = '';
    payload['StuId'] = StuId;
    this.umsService.RegnTemp(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.Validate(EcId, RgNo, CShSnNo, StuCgId, CoCode);

      } else {
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  Validate(EcId, RgNo, CShSnNo, CgCode, CoCode) {
    this.spinner.show();
    const payload = {};
    payload['Batch'] = '';
    payload['EcId'] = EcId;
    payload['Inst'] = this.InstId;
    this.umsService.ValidateTemp(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.checkTemp(RgNo, CShSnNo, CgCode, CoCode);
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  checkTemp(RgNo, CShSnNo, CgCode, CoCode) {
    this.spinner.show();
    const payload = {};
    payload['RgNo'] = RgNo;
    payload['SnNo'] = CShSnNo;
    payload['CgCode'] = CgCode;
    payload['CoCode'] = CoCode;
    this.umsService.checkTemp(payload).subscribe((res) => {
      
      if (res.data[0]['Mesg'] != '') {
        this.spinner.hide();
        let data = {};
        data['message'] = res.data[0]['Mesg'];
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
          AlertboxComponent,
          data
        );

      }
      else if (res.data[0]['Mesg'] == '') {
        this.spinner.hide();
        this.next.emit();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }



  loadsettingspage() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', Validators.required)
              );
            } else {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
              );
            }
          } else {
            if (element.FormPattern == '') {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }

          }
        }
      });
      this.admissionDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.getCourseData(this.Course);
      this.getCollege();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
  UpdateQualificationDetails() {
    for (let i = this.selectedCheckboxes.length - 1; i >= 0; i--) {
      if (this.selectedCheckboxes[i].EsType === 'P') {
        this.selectedCheckboxes.splice(i, 1);
      }
    }
    if (this.selectedCheckboxes.length == 0) {
      this.noCheckboxSelected = true
      return
    }
    else {
      this.disabled = false;
      if (typeof this.selectedCheckboxes[0] === "string") {
        this.update()
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        this.validateCheckboxesForItem();
        const isEmpty = Object.keys(this.validationErrors).length === 0;

        if (!isEmpty) {
          this.disabled = true;
           this.disabledCheckbox =false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
         this.savedisabled = true;

        } else if (isEmpty) {
          this.disabled = false;
           this.disabledCheckbox =true;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
          this.savedisabled = false;
          this.update();

        }

      }

    }


  }
  UpdScrtDetails(){
    this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    // payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['SessionId'] = this.snNo;
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.first.emit();
        location.reload();
      }
      else{
        this.spinner.hide();
        
      }
    })
  }
  // getTabName(e){
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }
  update() {
    if (this.admissionDetailsForm.invalid) {
         this.SubmitFormarkAsTouched();
    }
          this.UpdateScrutiny();
  }
  UpdateScrutiny(){
   // console.log("in update scrutiny");
    let StuAcadId = sessionStorage.getItem('StuAcadId');
    // this.submitButton = false;
    // this.updateButton = true;
    this.spinner.show();
    let payload = this.admissionDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuCoLvl = parseInt(payload.StuCoLvl);
    payload.StuEmId = parseInt(payload.StuEmId);
    if (this.selectedCheckboxes.length == 0) {
      payload.StuSubjectRg = [''];
    }

    // payload.SessionId = this.session;
    payload.SessionId = this.snNo;
    if (typeof this.selectedCheckboxes[0] === "string") {
      const result = [this.selectedCheckboxes.join(',')];
      payload.StuSubjectRg = result;
    } else if (typeof this.selectedCheckboxes[0] == "object") {
      let selectedSubjects = [...this.selectedCheckboxes];
      for (let i = selectedSubjects.length - 1; i >= 0; i--) {
        if (selectedSubjects[i].EsType === 'G') {
          selectedSubjects.splice(i, 1);
        }
      }
      let EsCodeArray = selectedSubjects.map(item => item.EsCode);
      const result = [EsCodeArray.join(',')];
      payload.StuSubjectRg = result;
    }
    let combinedValues = []; 
    this.selectedCheckboxes.forEach(item => {
      if (item.EsType === 'G') {
        combinedValues.push(`${item.EsCode}-${item.EsId}`);
      } else if (item.EsType === 'S') {
        combinedValues.push(`${item.EsCode}-${item.EsParent}`);
      }
    });

    const result2 = [combinedValues.join(',')];
    payload['StuAcadId'] = parseInt(StuAcadId);
    payload['StuSubjectRgCopy'] = result2
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
    this.umsService.updateAddmissionDetails(payload).subscribe(res => {
      if(res.status){
    //this.saveTopicGuide();
    this.umsService.setTabSaved('admissionTab');
    if (this.tabs &&
    this.umsService.isRequiredTabsSaved(this.tabs)) {
  const data = {};
  data['message'] =
    'Are You Sure You Have Updated ' +
    this.tabs +
    ' Tabs. Do You Want To Proceed?';

  data['title'] = 'Alert';
  data['icon'] = 'fa fa-question';

  this.dialogRef =
    this.modalPopupService.openPopup<ConformationModelComponent>(
      ConformationModelComponent,
      data
    );
  this.dialogRef.afterClosed().subscribe(result => {
    if (result === 'yes') {
      this.UpdScrtDetails();
      if (this.tabs?.includes('Wrong Payment')) {
      this.router.navigate(['/Fees']);
      }
    }
  });
}
      sessionStorage.setItem("StuEmId", payload.StuEmId);
      sessionStorage.setItem("StuCoId", payload.StuCoId);
      sessionStorage.setItem("StuCgId", payload.StuCgId);
      this.updateSubjectSelection();
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.next.emit();
      this.dialogRef.afterClosed().subscribe((result) => {
        
      });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    }
    );
  }

  getFacultyData() {
    this.spinner.show();
    const payload = {};
    this.Subjects = [];
    this.GroupData = [];
    this.umsService.fetchFaculty(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.Subjects = [];
        this.GroupData = [];
        this.facultyList = res.data;
        this.filteredFacultyList = this.facultyList.slice();
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getCourseData(id) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = this.Course;
     this.filteredCourseList = [];
    this.filteredStreamList = [];
    this.StrCode = '';
    this.filteredExamList = [];
    this.filteredSubList = [];
    this.selectedValues = [];
    this.Subjects = [];
    this.GroupData = [];
    this.SubjectName = [];
    this.AllSub = [];
    this.Sub = [];
    this.filteredstucourseClgMapListList = [];
        this.groupedSubjects = {}
    this.groupedSubjects2 = {}
    this.umsService.fetchCourseType(payload).subscribe(res => {
      if(res.status){
        this.Subjects = [];
      this.GroupData = [];
      this.spinner.hide()
      this.courseList = res.data;
      this.filteredCourseList = this.courseList.slice();
      this.CourseType = res.data[0].CourseLevel;
      if(this.Course != ''){
        this.admissionDetailsForm.controls['StuFacId'].setValue(res.data[0]['CoFcCode']);
        this.admissionDetailsForm.controls['StuCoId'].setValue(this.Course);
      }
      
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }



  getExamStreamData(id) {
    this.spinner.show()
    this.filteredStreamList = [];
    this.StrCode = '';
    this.BranchId = 0;
    this.filteredExamList = [];
    this.filteredSubList = [];
    this.selectedValues = [];
      this.subjectsData = false;
    this.Subjects = [];
    this.GroupData = []
    this.SubjectName = [];
    this.AllSub = [];
    this.Sub = [];
    this.filteredstucourseClgMapListList = [];
    this.CourseCode = id;
        this.groupedSubjects = {}
    this.groupedSubjects2 = {}
    sessionStorage.setItem("CoCodeee", this.CourseCode)
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.fetchCourseBranch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
      }
      else {
        this.spinner.hide()
        this.BranchId = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    }
    );

    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.Subjects = [];
    this.GroupData = []
    this.umsService.fetchExam(payload2).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.Subjects = [];
        this.GroupData = []
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    const payload3 = {};
    payload3['CoCode'] = id;
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.stucourseClgMapList = res.data;
        this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
        if(this.College != ''){
          this.admissionDetailsForm.controls['StuCgId'].setValue(this.College);
        }
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getExam(id) {
    this.spinner.show();
    this.Subjects = [];
    this.GroupData = []
    this.optData = '';
    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.umsService.fetchExam(payload2).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.Subjects = [];
        this.GroupData = []
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

  }

  getSubData(id) {
  
    if(id.EmStreams == 'N'){
    this.BranchShow =false;
    this.spinner.show()
    const payload = {};
    payload['EsEmId'] = id.EmId;
    payload['EsStrId'] = this.admissionDetailsForm.value.StuBrId;
    this.umsService.fetchSubs(payload).subscribe(async res => {
      if(res.status){
        this.spinner.hide()
      this.Subjects = [];
      this.GroupData = []
      this.selectedCheckboxes = [];
      this.SubjectName = [];
      this.AllSub = [];
      this.Sub = []
            this.groupedSubjects = {}
      this.groupedSubjects2 = {}
      await this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.subList = res.data;
      this.filteredSubList = this.subList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    }else{
      this.BranchShow =true;
    }
   
  }

  getSubDatawithBranch(id) {
    console.log(
      'get sub data called',id
    );
    // if(id.EmStreams == 'N'){
    // this.BranchShow =false;
    // }else{
    //   this.BranchShow =true;
    // }
    this.spinner.show()
    let data = this.admissionDetailsForm.value
    const payload = {};
    payload['EsEmId'] = this.admissionDetailsForm.value.StuEmId;
    payload['EsStrId'] = id.StrId;
    this.umsService.fetchSubs(payload).subscribe(async res => {
      if(res.status){
        this.spinner.hide()
      this.Subjects = [];
      this.GroupData = []
      this.selectedCheckboxes = [];
      this.SubjectName = [];
      this.AllSub = [];
      this.Sub = []
            this.groupedSubjects = {}
      this.groupedSubjects2 = {}
      await this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.subList = res.data;
      this.filteredSubList = this.subList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
  getExamSubMapFetch(EmId, BranchId) {
    this.Subjects = [];
    this.GroupData = [];
    this.Subs = false;
    this.OptSub = false;
        this.groupedSubjects = {}
    this.groupedSubjects2 = {}
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = this.admissionDetailsForm.value.StuBrId;
    this.umsService.getExamSubMapFetch(payload).subscribe(async res => {
      if(res.status){
          this.subjectsData = true;
        this.spinner.hide();
        this.SubjectData = res.data.children;
        this.SubjectData.forEach(element => {
          if (element.EsType == 'S') {
            this.Subs = true;
            if (this.Subjects.indexOf(element.EsCode) === -1) {
              this.Subjects.push(element.EsCode);
              this.SubjectName.push(element.EsName);
              this.Sub.push(element.EsOpCode)
              this.AllSub.push(element)
              if (element.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element.EsOpCode);
                }
              }
            }
            if (element.EsOpCode == " " && element.EsType == 'S') {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }
            }
            this.newSelectedValues.forEach(element2 => {
              if (element2.Code == element.EsCode && element2.Id == element.EsParent) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element);
                }
  
              }
            })
          }
          else if (element.EsType == 'G') {
            this.OptSub = true;
            if (element.EsOpCode !== ' ') {
  
              const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element.EsOpCode);
              }
            }
            const isDuplicate = this.GroupData.some((item: any) => item.EsId === element.EsId);
            if (!isDuplicate) {
              this.GroupData.push(element);
            }
            element.children.forEach(element1 => {
              if (element1.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element1.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element1.EsOpCode);
                }
              }
  
              if (element1.EsOpCode == " ") {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element1);
                }
              }
  
              this.newSelectedValues.forEach(element2 => {
  
                if (element2.Code == element1.EsCode && element2.Id == element1.EsParent) {
                  const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                  if (!isDuplicate) {
                    this.selectedCheckboxes.push(element1);
                  }
  
                }
  
              })
            });
  
            this.newSelectedValues.forEach(element2 => {
  
              if (element2.Code == element.EsCode && element2.Id == element.EsId) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element);
                }
  
              }
  
            })
            for (const value of this.newSelectedValues) {
              element.children.forEach(element2 => {
                if (element2.EsOpCode !== ' ') {
                  const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
                  if (!DupOpt) {
                    this.selectedOptions.push(element2.EsOpCode);
                  }
                }
              });
            }
  
          } else {
          }
        });
        await this.getOptionData(EmId, BranchId);
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });


  }

  getOptDataForGroup(group: any) {
    return this.optData.find(item => item.OpCode === group.EsOpCode);
  }

  minmaxsubject(q) {
    q.forEach(element => {
      if (element.EsOpCode != ' ') {
        let EsOpCode = element.EsOpCode
        this.optData.forEach(element1 => {
          if (element1.OpCode === EsOpCode) {
            let OptionData = element1
            this.code = OptionData.OpCode
            this.msg = `Minimum = ` + OptionData.OpMin + ` & Maximum = ` + OptionData.OpMax
          }
        });
      }
    });
    return this.msg
  }



  getOptionData(EmId, BranchId) {
    this.optData = '';
    this.spinner.show();
    const payload = {};
        this.groupedSubjects = {}
    this.groupedSubjects2 = {}
    payload['OpEmId'] = EmId;
    payload['OpStrId'] = this.admissionDetailsForm.value.StuBrId;
    this.umsService.getOption(payload).subscribe(async(res) => {
      if (res.status == true) {
        this.spinner.hide();
        const filteredArray = res.data.filter(item => this.selectedOptions.includes(item.OpCode));
        
        this.optData = filteredArray;
        this.MinMax = true;
      }
      else {
        this.spinner.hide();
        this.MinMax = false;
      }
      await this.groupSubjects();
      await this.groupSubjects2();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getClgMapp(id) {
    this.spinner.show();
    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide();
      this.stucourseClgMapList = res.data;
      this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getBrId(id, code) {
    this.BranchId = id;
    this.StrCode = code;
  }

  SubmitFormarkAsTouched() {
    this.spinner.show()
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.admissionDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
            }
          }
        }
      });
      this.admissionDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }


  submitAddmissionDetails() {

    if (this.admissionDetailsForm.invalid) {
        this.SubmitFormarkAsTouched();
    } else {
      this.submit()
    }

  }

  submit() {
    for (let i = this.selectedCheckboxes.length - 1; i >= 0; i--) {
      if (this.selectedCheckboxes[i].EsType === 'P') {
        this.selectedCheckboxes.splice(i, 1);
      }
    }

    if (this.selectedCheckboxes.length == 0) {
      // this.validateCheckboxesForItem();
      this.noCheckboxSelected = true
      return
    }

    else {

      this.disabled = false;
      if (typeof this.selectedCheckboxes[0] === "string") {
        this.submitFinal()
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        // this.validateCheckboxesForItem();
        const isEmpty = Object.keys(this.validationErrors).length === 0;

        if (!isEmpty) {
          this.disabled = true;
            this.disabledCheckbox =false;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
         this.savedisabled = true;
         

        } else if (isEmpty) {
          this.disabled = false;
            this.disabledCheckbox =true;
        console.log('this.disabledCheckbox',this.disabledCheckbox)
          this.savedisabled = false;
          this.submitFinal();

        }

      }
    }
  }

  submitFinal() {
   // console.log("in submit final");
    let combinedValues = [];
    // this.submitButton = true;
    // this.updateButton = false;
    this.spinner.show();
    let payload = this.admissionDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuCoLvl = parseInt(payload.StuCoLvl);
    payload.StuEmId = parseInt(payload.StuEmId);
    // payload.SessionId = this.session;
    payload.SessionId = this.snNo;
    if (typeof this.selectedCheckboxes[0] === "string") {
      const result = [this.selectedCheckboxes.join(',')];
      payload.StuSubjectRg = result;
    } else if (typeof this.selectedCheckboxes[0] == "object") {
      let selectedSubjects = [...this.selectedCheckboxes];
      for (let i = selectedSubjects.length - 1; i >= 0; i--) {
        if (selectedSubjects[i].EsType === 'G') {
          selectedSubjects.splice(i, 1);
        }
      }
      let EsCodeArray = selectedSubjects.map(item => item.EsCode);
      const result = [EsCodeArray.join(',')];
      payload.StuSubjectRg = result;
    }
    this.selectedCheckboxes.forEach(item => {
      if (item.EsType === 'G') {
        // For EsType G, storing EsCode-EsId
        combinedValues.push(`${item.EsCode}-${item.EsId}`);
      } else if (item.EsType === 'S') {
        // For EsType S, storing EsCode-EsParent
        combinedValues.push(`${item.EsCode}-${item.EsParent}`);
      }
    });

    const result2 = [combinedValues.join(',')];
    payload['StuSubjectRgCopy'] = result2
    this.spinner.hide();
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
    this.umsService.addAddmissionDetails(payload).subscribe(res => {
      sessionStorage.setItem("StuEmId", payload.StuEmId);
      sessionStorage.setItem("StuCoId", payload.StuCoId);
      sessionStorage.setItem("StuCgId", payload.StuCgId);
      //this.saveTopicGuide();
      this.submitSubjectSelect()
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
     
      this.dialogRef.afterClosed().subscribe((result) => {
       
      });

      this.next.emit();

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
     this.dialogRef.afterClosed().subscribe((result) => {
      });
    }
    );
  }
  back() {
    this.prev.emit(false);
  }


  fetchStudyMode() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.studyModeList = res.data;
        this.filteredstudyModeList = this.studyModeList.slice();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }


  fetchStudentType() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.sTypeList = res.data;
        this.filteredsTypeList = this.sTypeList.slice();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }



  scrutenylevelCheck(item) {
    this.spinner.show();
    let colgCode = item.CgCode;
    let code = sessionStorage.getItem("CoCodeee")
    const payload = {};
    payload['CoCode'] = code;
    payload['CgCode'] = colgCode;
    payload['SessionId'] = this.snNo;

    this.umsService.getAssignLevel(payload).subscribe((res) => {
      if (res.data.length < 1) {
      
        this.spinner.hide();
        let data = {}
        data['message'] = "For the selected college and course admissions are not open"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.disabled = false;
          this.showtxt = false;
        });
      } else {
        this.spinner.hide();
           this.disabled = false;
        this.showtxt = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  cutoff(code) {
    this.spinner.show()
    this.notOpen = false;
    this.AdmClosed = false;
    this.showtxt = false;
    this.disabled = false;
    let data = this.admissionDetailsForm.value
    const payload = {};
    payload['SessionID'] = this.snNo;
    payload['CoCgCgCode'] = code;
    payload['CoCgCoCode'] = data.StuCoId;
    payload['InCode'] = "ADM";
    payload['EmId'] = '';
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.showtxt = false;
        const todayDate = new Date();

        for (const element of res.data) {
          const fromdate = new Date(element['CutOffDateFrom']);
          const toDate = new Date(element['CutOffDate']);

          // Set hours, minutes, seconds, and milliseconds to 0 for accurate date comparison
          todayDate.setHours(0, 0, 0, 0);
          fromdate.setHours(0, 0, 0, 0);
          toDate.setHours(0, 0, 0, 0);
          if (todayDate >= fromdate && todayDate <= toDate) {
            this.notOpen = false;
            this.disabled = false
            this.AdmClosed = false;
            break; // Exit the loop if the registration is open
          } else if (todayDate < fromdate) {
            this.FromDate = fromdate;
            this.notOpen = true;
            this.disabled = true;
            this.AdmClosed = false;
             this.disabledCheckbox=true
        console.log('this.disabledCheckbox',this.disabledCheckbox)
            this.savedisabled = true;
            break; // Exit the loop if registration is not open yet
          }
        }

        // If none of the conditions were met, it means today's date is after all the cutoff dates
        if (this.AdmClosed === undefined) {
          this.AdmClosed = true;
            this.disabledCheckbox =true
        console.log('this.disabledCheckbox',this.disabledCheckbox)
          this.savedisabled = true;
          this.disabled = true
        }
      }
      else {
        this.spinner.hide()
        this.showtxt = false;
        this.disabled = false;
          this.disabledCheckbox =false
        console.log('this.disabledCheckbox',this.disabledCheckbox)
        this.savedisabled = false;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getSessionData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.sessionList = res.data;
        this.SessionFilterList = this.sTypeList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.sessionList = [];
      let data = {}
      this.spinner.hide();
      // data['message'] = ERROR.error.message
      // data['title'] = 'Information'
      // data['icon'] = 'fas fa-box-open'
      // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

    });
  }

  submitSubjectSelect() {
   // console.log("in submit subject select");
    let combinedValues = [];
        let combinedNameValues = [];
    // this.submitButton = true;
    // this.updateButton = false;
    this.spinner.show();
    let payload2 = {}
    let payload = this.admissionDetailsForm.value;
    payload.StuId = parseInt(sessionStorage.getItem('StudentPersonalId'));
    payload.SubEmId = payload.SubEmId;
    payload.SubSession = this.snNo;
    if (typeof this.selectedCheckboxes[0] === "string") {
      const result = [this.selectedCheckboxes.join(',')];
      payload2['StuSubjectRg'] = result
    } else if (typeof this.selectedCheckboxes[0] == "object") {
      let selectedSubjects = [...this.selectedCheckboxes];
      for (let i = selectedSubjects.length - 1; i >= 0; i--) {
        if (selectedSubjects[i].EsType === 'G') {
          selectedSubjects.splice(i, 1);
        }
      }
      let EsCodeArray = selectedSubjects.map(item => item.EsCode);
      const result = [EsCodeArray.join(',')];
      payload2['StuSubjectRg'] = result
    }
    this.selectedCheckboxes.forEach(item => {
      if (item.EsType === 'G') {
        // For EsType G, storing EsCode-EsId
        combinedValues.push(`${item.EsCode}-${item.EsId}`);
      } else if (item.EsType === 'S') {
        // For EsType S, storing EsCode-EsParent
        combinedValues.push(`${item.EsCode}-${item.EsParent}`);
          combinedNameValues.push(`${item.EsCode};${item.EsName};${item.EsOpCode == ' ' ? 'NA' : item.EsOpCode}`);
      }
    });
        const NameResult = [combinedNameValues.join(',')];
    const result2 = [combinedValues.join(',')];
    payload2['StuSubjectRgCopy'] = result2
    payload2['StuSubjectName'] = NameResult
    payload2['SubSession'] = this.snNo;
    payload2['SubFacId'] = payload.StuFacId
    payload2['SubCoId'] = payload.StuCoId
    payload2['SubBrId'] = payload.StuBrId
    payload2['SubEmId'] = payload.StuEmId
    payload2['SubCgId'] = payload.StuCgId
    payload2['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));
    this.umsService.addSubjectSelectionDetails(payload2).subscribe(res => {
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      }
    );
  }

  updateSubjectSelection() { 
    if (this.admissionDetailsForm.invalid) {
     
    } else {
      let SubSecId = sessionStorage.getItem('SubSecId');
      this.spinner.show();
      let payload2 = {}
      let payload = this.admissionDetailsForm.value;
      payload.StuId = parseInt(payload.StuId);
      payload.SubEmId = String(payload.SubEmId);
      payload.SubSession = String(payload.SubSession);
      if (this.selectedCheckboxes.length == 0) {
        payload.StuSubjectRg = [''];
      }

      
      if (typeof this.selectedCheckboxes[0] === "string") {
        const result = [this.selectedCheckboxes.join(',')];
        payload2['StuSubjectRg'] = result
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        let selectedSubjects = [...this.selectedCheckboxes];
        for (let i = selectedSubjects.length - 1; i >= 0; i--) {
          if (selectedSubjects[i].EsType === 'G') {
            selectedSubjects.splice(i, 1);
          }
        }
        let EsCodeArray = selectedSubjects.map(item => item.EsCode);
        const result = [EsCodeArray.join(',')];
        payload2['StuSubjectRg'] = result
      }
      let combinedValues = []; 
      let combinedNameValues = [];
      this.selectedCheckboxes.forEach(item => {
        if (item.EsType === 'G') {
          combinedValues.push(`${item.EsCode}-${item.EsId}`);
        } else if (item.EsType === 'S') {
          combinedValues.push(`${item.EsCode}-${item.EsParent}`);
          combinedNameValues.push(`${item.EsCode};${item.EsName};${item.EsOpCode == ' ' ? 'NA' : item.EsOpCode}`);
        }
      });

      const result2 = [combinedValues.join(',')];
      const NameResult = [combinedNameValues.join(',')];
      payload2['StuSubjectRgCopy'] = result2
            payload2['StuSubjectName'] = NameResult
      payload2['SubSecId'] = parseInt(SubSecId);
      payload2['SubSession'] = this.snNo;
      payload2['SubFacId'] = payload.StuFacId
      payload2['SubCoId'] = payload.StuCoId
      payload2['SubBrId'] = payload.StuBrId
      payload2['SubEmId'] = payload.StuEmId
      payload2['SubCgId'] = payload.StuCgId
      payload2['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));
      this.umsService.updateSubjectSelectionDetails(payload2).subscribe(res => {
        if(res.status){
          this.spinner.hide();
        }
        else{
          this.spinner.hide();
       
        }
        
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      }
      );
    }
  }

  ChangeStudyMode(id){
    let StudyMode = this.studyModeList.filter(data => data.CdCode == id.EmSrNo);
    this.admissionDetailsForm.controls['StuStyMode'].setValue(StudyMode[0]['CdCode'])
  }

    prepopulationContact() {
      this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId);
    this.umsService.fetchContactDetails(payload).subscribe(res => {
      // if (res.status) {
        this.spinner.hide();
        if (res.data[0].StuNationality === 'OS') {
          this.umsService.studentProgressList['StudentReservation'] = 1;
        }
      // } 
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })

  }
  
    isCheckboxDisabled(checkbox: any): boolean {
    // Check if the current checkbox is related to a selected checkbox (EsCombCode or EsNoComb)
    // const relatedCheckboxSelected = this.selectedCheckboxes.some((selected) => 
    //   selected.EsCombCode === checkbox.EsCode || selected.EsNoComb === checkbox.EsCode
    // );
   // Check if the current checkbox is related to any selected checkbox
   const relatedCheckboxSelected2 = this.selectedCheckboxes.some((selected) => {
    const combCodes = selected.EsCombCode ? selected.EsCombCode.split(',') : [];
    const noCombCodes = selected.EsNoComb ? selected.EsNoComb.split(',') : [];
    return combCodes.includes(checkbox.EsCode) || noCombCodes.includes(checkbox.EsCode);
  });

    // Disable checkboxes that are related to a selected checkbox
    // return relatedCheckboxSelected;
    return relatedCheckboxSelected2;
  }

    getSubjectOfferDetails(): string[] {
    const offerDetails: string[] = [];
  
    // Iterate over the selected checkboxes and check for EsCombCode and EsNoComb
    this.selectedCheckboxes.forEach(checkbox => {
      let offerDetail = `${checkbox.EsCode} - `;
  
      // Split and format EsCombCode values
      const mustOfferCodes = checkbox.EsCombCode ? checkbox.EsCombCode.split(',').map(code => code.trim()) : [];
      const mustOffer = mustOfferCodes.length > 0 ? `Must Offer: ${mustOfferCodes.join(', ')}` : null;
  
      // Split and format EsNoComb values
      const cantOfferCodes = checkbox.EsNoComb ? checkbox.EsNoComb.split(',').map(code => code.trim()) : [];
      const cantOffer = cantOfferCodes.length > 0 ? `Can't Offer: ${cantOfferCodes.join(', ')}` : null;
  
      // Construct the note for the current subject
      if (mustOffer || cantOffer) {
        if (mustOffer && cantOffer) {
          offerDetail += `${mustOffer}, ${cantOffer}`;
        } else if (mustOffer) {
          offerDetail += mustOffer;
        } else if (cantOffer) {
          offerDetail += cantOffer;
        }
        
        // Add the offer details for this checkbox to the list
        offerDetails.push(offerDetail);
      }
    });
  
    return offerDetails;
  }
  
    getSubKeys(): string[] {
    return Object.keys(this.groupedSubjects);
  }

  
  getSubKeysForGroup(groupCode: string): string[] {
    return this.groupedSubjects2[groupCode] ? Object.keys(this.groupedSubjects2[groupCode]) : [];
}

  groupSubjects() {
    this.AllSub.forEach((subjectItem) => {
      const subValue = subjectItem.EsOpCode;
    
      if (!this.groupedSubjects[subValue]) {
        this.groupedSubjects[subValue] = [];
      }
    
      // Check if the subjectItem is already present in the array
      const isDuplicate = this.groupedSubjects[subValue].some(
        (item:any) => item.EsCode === subjectItem.EsCode
      );
    
      if (!isDuplicate) {
        this.groupedSubjects[subValue].push(subjectItem);
      }
    });
    
  }

    groupSubjects2(){
    this.groupedSubjects2 = {};

    this.GroupData.forEach((group) => {
      const groupCode = group.EsCode; // Unique identifier for the group
      if (!this.groupedSubjects2[groupCode]) {
        this.groupedSubjects2[groupCode] = {}; // Initialize group
      }
  
      // Iterate over children (subjects) of the group
      group.children.forEach((subjectItem) => {
        const subValue = subjectItem.EsOpCode || 'Mandatory'; // Use 'Mandatory' for blank options
        if (!this.groupedSubjects2[groupCode][subValue]) {
          this.groupedSubjects2[groupCode][subValue] = []; // Initialize option category
        }
        this.groupedSubjects2[groupCode][subValue].push(subjectItem);
      });
    });
  
  }

    isSaveEnabled(): boolean {
      return Object.keys(this.validationErrors).length === 0 || this.savedisabled === false;
  }
    isUpdateEnabled(): boolean {
      return Object.keys(this.validationErrors).length === 0 || this.savedisabled === false;
  }

    onSaveClick(): void {
    if (this.CourseType === 'phd') {
    this.submitFinal();
    return;
  }
    this.validateCheckboxesForItem();
    if (this.getValidationErrorsKeys().length > 0) {
        const errorMessages = Object.values(this.validationErrors).join('<br>'); // Use <br> for line breaks
        const data = {
            message2: errorMessages,
            title: 'Validation Errors',
            icon: 'fas fa-exclamation-circle',
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    } else {
      this.submitAddmissionDetails()
    }
}

  onUpdateClick(): void {
    if (this.CourseType === 'phd') {
    this.update();
    return;
  }
    this.validateCheckboxesForItem();
    if (this.getValidationErrorsKeys().length > 0) {
        const errorMessages = Object.values(this.validationErrors).join('<br>'); // Use <br> for line breaks
        const data = {
            message2: errorMessages,
            title: 'Validation Errors',
            icon: 'fas fa-exclamation-circle',
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    } else {
      this.UpdateQualificationDetails()
   
    }
}
// saveTopicGuide() {
//   const payload = {
//     StuId: parseInt(this.StudentPersonalId),
//     StuTopic: this.admissionDetailsForm.value.StuTopic,
//     StuGuideName: this.admissionDetailsForm.value.StuGuideName
//   };

//   this.umsService.StudentOtherDetails(payload).subscribe(res =>{
//  if (res.status) {
//         console.log('Student Other Details Saved Successfully');
//       } else {
//         console.log('Failed to save Student Other Details');
//       }
//     },
//     (error: HttpErrorResponse) => {
//       console.error('Error:', error);
//     });
// }
}